import * as React from 'react';
import accounting from 'accounting';
import { Debounce } from 'react-throttle';

import Select from 'src/components/common/Select2';

import { ISelectOption } from 'src/components/common/Select2/components/SelectOption/SelectOption';

import { goToPartDetail, partDetailUrl } from 'src/utils/navigation';
import { isMobile } from 'src/utils/responsiveHelpers';
import defaultImage from 'src/assets/defaultImage';
import './Item.scss';
import env from 'src/shared/env';
import Alert from 'src/components/common/Alert/Alert';
import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';

interface IItemProps {
  id: number;
  mfc: string;
  name: string;
  image: string;
  description: string;
  qty: number;
  price: number;
  retailPrice: number;
  total: number;
  inStock: boolean;
  shipmentMarking: string;
  warrantyProvider: string;
  dispatch: string;
  deliverFrom: string;
  warehouse: string;
  warranties: ISelectOption[];
  handleItemUpdate(
    itemId: number,
    name: string,
    mfc: string,
    quantity?: number,
    shipmentMarking?: string,
    warrantyProvider?: string,
    claims?: string
  ): void;
  handleRemoveItem(itemId: number, name: string): void;
  handleAddToCart(
    claims: string,
    delivery: string,
    deliveryLocation: string,
    oneTimeAddress: null,
    partNumber: string,
    quantity: number,
    rushOrder: boolean,
    shipmentMarking: string,
    shipsfrom: string,
    ticketNumber: string,
    warrantyProvider: string
  ): void;
  t?: any;
  replacementMfc: string;
  replacementPart: string;
  alternateProductNumber: string;
  alternateProductManufacturer: string;
  oemProductNumber: string;
  oemProductManufacturer: string;
}

interface IItemsState {
  isMobile: boolean;
  showMarks: boolean;
  showShipmentAlert: boolean;
  showDispatchClaimsAlert: boolean;
  qty: string;
}

class Item extends React.Component<IItemProps, IItemsState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile(),
      showMarks: false,
      showShipmentAlert: false,
      showDispatchClaimsAlert: false,
      qty: '1'
    };
  }

  private handleShowMarks = () => {
    this.setState(prevState => ({ showMarks: !prevState.showMarks }));
  };

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  private renderWarrantyProviders = () => {
    const selectedProvider = this.props.warranties.find(
      wp => wp.value === this.props.warrantyProvider
    );
    return (
      <Select
        options={[{ name: 'None', value: null }, ...this.props.warranties]}
        selected={selectedProvider}
        placeholder={'None'}
        label={'Add Warranty Provider:'}
        onSelect={sel => {
          this.props.handleItemUpdate(
            this.props.id,
            this.props.name,
            this.props.mfc,
            this.props.qty,
            this.props.shipmentMarking,
            sel.value,
            this.props.dispatch
          );
        }}
      />
    );
  };

  private addToCart = () => {
    if(this.state.isMobile){
      const section = document.querySelector( '#rp-lists-main-area' );
      section.scrollIntoView();
    }else{
      window.scrollTo(0, 0);
    }
    if (this.checkForErrors()) {
      return;
    }
    this.props.handleAddToCart(
      this.props.dispatch,
      null,
      null, // this.props.deliverFrom,
      null,
      `${this.props.mfc}  ${this.props.name}`,
      Number(this.state.qty),
      false,
      this.props.shipmentMarking,
      'closest', // this.props.warehouse,
      '', // ticket number
      this.props.warrantyProvider
    );
  };

  private handleChangeQty = (e: any) => {
    this.setState({ qty: e.target.value });
    this.props.handleItemUpdate(
      this.props.id,
      this.props.name,
      this.props.mfc,
      Number(e.target.value),
      this.props.shipmentMarking,
      this.props.warrantyProvider,
      this.props.dispatch
    );
  };

  private handleChangeShipmentMarking = (e: any) => {
    const shipmentMarking = e.target.value;

    if (
      !shipmentMarking ||
      (shipmentMarking !== ' ' &&
        !startEndWithWhiteSpacesValidation(shipmentMarking))
    ) {
      if (shipmentMarking.length === 30) {
        this.setState({
          showShipmentAlert: true
        });
      } else {
        this.setState({
          showShipmentAlert: false
        });
      }
      this.props.handleItemUpdate(
        this.props.id,
        this.props.name,
        this.props.mfc,
        this.props.qty,
        shipmentMarking,
        this.props.warrantyProvider,
        this.props.dispatch
      );
    }
  };

  private handleChangeDispatchClaims = (e: any) => {
    const claims = e.target.value;

    if (
      !claims ||
      (claims !== ' ' && !startEndWithWhiteSpacesValidation(claims))
    ) {
      if (claims.length > 15) {
        this.setState({
          showDispatchClaimsAlert: true
        });
      } else {
        this.setState({
          showDispatchClaimsAlert: false
        });
      }
      this.props.handleItemUpdate(
        this.props.id,
        this.props.name,
        this.props.mfc,
        this.props.qty,
        this.props.shipmentMarking,
        this.props.warrantyProvider,
        claims
      );
    }
  };

  private renderMarksArea = () => {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div className="rp-list-item--marks-inputs rp-list-item--marks-qty">
          <label>{t('myFavourites.qty')}:</label>
          <Debounce time="2000" handler="onChange">
            <input
              name="qty"
              type="number"
              defaultValue={
                this.props.qty !== null && this.props.qty > 0
                  ? this.props.qty.toString()
                  : '1'
              }
              min={1}
              onChange={this.handleChangeQty}
            />
          </Debounce>
        </div>
        <div className="rp-list-item--marks-inputs rp-list-item--marks-shipment">
          <label className={this.props.warrantyProvider ? 'disabled' : ''}>
            {t('myFavourites.shipmentMarking')}:
          </label>
          <Debounce time="2000" handler="onChange">
            <input
              name="shipmentMarking"
              type="text"
              className={this.props.warrantyProvider ? 'disabled' : ''}
              defaultValue={
                this.props.shipmentMarking ? this.props.shipmentMarking : ''
              }
              onChange={e => this.handleChangeShipmentMarking(e)}
              disabled={this.props.warrantyProvider ? true : false}
              maxLength={30}
            />
          </Debounce>
        </div>
        {env.REACT_APP_BASE_ENVIRONMENT === 'US' &&
          this.props.warranties.length > 0 && (
            <React.Fragment>
              <div className="rp-list-item--marks-inputs rp-list-item--marks-warranty">
                {this.renderWarrantyProviders()}
              </div>
              <div className="rp-list-item--marks-inputs rp-list-item--marks-claims">
                {this.props.warrantyProvider && (
                  <React.Fragment>
                    <label>Dispatch/Claims:</label>
                    <Debounce time="2000" handler="onChange">
                      <input
                        name="claims"
                        type="text"
                        defaultValue={
                          this.props.dispatch ? this.props.dispatch : ''
                        }
                        onChange={e => this.handleChangeDispatchClaims(e)}
                        maxLength={30}
                      />
                    </Debounce>
                  </React.Fragment>
                )}
              </div>
            </React.Fragment>
          )}
      </React.Fragment>
    );
  };

  public renderMobile() {
    const { t } = this.props;
    return (
      <React.Fragment>
        {this.state.showShipmentAlert && (
          <Alert
            styleClass="rp-list-item-alert"
            message={
              // 'Maximum allowable length for Shipment marking is 30 characters'
              `${t('productFieldErrors.maxShipmentCharacterErr', {
                count: 30
              })}`
            }
            icon={'rpds-warning'}
            handleCloseAlert={() => {
              this.setState({
                showShipmentAlert: false
              });
            }}
            type={'warning'}
          />
        )}
        {this.state.showDispatchClaimsAlert && (
          <Alert
            styleClass="rp-list-item-alert"
            message={
              // 'Maximum allowable length for Dispatch/Claims marking is 15 characters'
              `${t('productFieldErrors.maxDispatchClaimsMarkingErr', {
                count: 15
              })}`
            }
            icon={'rpds-warning'}
            handleCloseAlert={() => {
              this.setState({
                showDispatchClaimsAlert: false
              });
            }}
            type={'warning'}
          />
        )}
        <div className="rp-list-item">
          <div className="rp-list-item-top">
            <div className="rp-list-item--image-area">
              <div
                className="image-container"
                style={{
                  backgroundImage: `url(${
                    this.props.image ? this.props.image : defaultImage
                  })`
                }}
              />
            </div>
            <div className="rp-list-item--info-area">
              <div>
                <div className="rp-list-item--name-area">
                  <a
                    className="rp-list-item--name-link"
                    href={partDetailUrl(
                      `${this.props.mfc}  ${this.props.name}`
                    )}
                    style={{ cursor: 'pointer' }}
                    onClick={e =>
                      goToPartDetail(`${this.props.mfc}  ${this.props.name}`)
                    }
                  >
                    {`${this.props.mfc} ${this.props.name}`}
                  </a>
                </div>
                <div className="rp-list-item--description-area">
                  {this.props.description}
                </div>
              </div>
              <div className="rp-list-item--stock-area">
                <span
                  className={
                    this.props.inStock
                      ? `rpds-check-circle stock-success-icon`
                      : `rpds-error stock-error-icon`
                  }
                />
                {this.props.inStock
                  ? `${t('common.inStock')}`
                  : `${t('common.outOfStock')}`}
              </div>
              <div className="rp-list-item--prices-area">
                <div className="rp-list-item--prices-single">
                  <label>MSRP </label>
                  {this.props.retailPrice
                    ? accounting.formatMoney(this.props.retailPrice)
                    : 'NA'}
                </div>
                <div className="rp-list-item--prices-single">
                  <label>{t('myFavourites.yourPrice')} </label>
                  {this.props.price
                    ? accounting.formatMoney(this.props.price)
                    : 'NA'}
                </div>
                <div className="rp-list-item--prices-single">
                  <label>{t('myFavourites.itemTotal')}</label>
                  {this.props.total
                    ? accounting.formatMoney(this.props.total)
                    : 'NA'}
                </div>
              </div>
            </div>
          </div>
          <div className="rp-list-item--marks-area">
            <div
              className="rp-list-item--marks-expandable"
              onClick={this.handleShowMarks}
            >
              {t('cartPage.orderDetails')}{' '}
              <span
                className={`${
                  this.state.showMarks ? 'rpds-remove' : 'rpds-add'
                }`}
              />
            </div>
            {this.state.showMarks && this.renderMarksArea()}
          </div>
          <div className="rp-list-item--buttons-area">
            <button
              className="secondary-button"
              onClick={e =>
                this.props.handleRemoveItem(this.props.id, this.props.name)
              }
            >
              {t('common.removeAction')}
            </button>
            <button className="primary-button" onClick={this.addToCart}>
              <span className="rpds-shopping-cart" />
              {t('myFavourites.addToCart')}
            </button>
            {this.props.alternateProductNumber !== null &&
            this.props.oemProductNumber === null ? (
              <button
                className="viewbutton"
                type="button"
                // href={partDetailUrl(
                //   `${this.props.alternateProductManufacturer}  ${this.props.alternateProductNumber}`
                // )}
                onClick={e => {
                  goToPartDetail(
                    `${this.props.alternateProductManufacturer}  ${this.props.alternateProductNumber}`
                  );
                }}
              >
                {t('myFavourites.viewnonoem')}
              </button>
            ) : (
              ''
            )}
            {this.props.oemProductNumber &&
            !this.props.alternateProductNumber ? (
              <button
                className="viewbutton"
                type="button"
                // href={partDetailUrl(
                //   `${this.props.oemProductManufacturer}  ${this.props.oemProductNumber}`
                // )}
                onClick={e => {
                  goToPartDetail(
                    `${this.props.oemProductManufacturer}  ${this.props.oemProductNumber}`
                  );
                }}
              >
                {t('myFavourites.viewoem')}
              </button>
            ) : (
              ''
            )}

            {this.props.replacementMfc && this.props.replacementPart ? (
              <button
                className="subavailable"
                onClick={e => {
                  goToPartDetail(
                    `${this.props.replacementMfc}  ${this.props.replacementPart}`
                  );
                }}
              >
                {t('myFavourites.subavailable')}
              </button>
            ) : (
              ''
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  public renderDesktop() {
    const { t } = this.props;
    return (
      <React.Fragment>
        {this.state.showShipmentAlert && (
          <Alert
            styleClass="rp-list-item-alert"
            message={
              // 'Maximum allowable length for Shipment marking is 30 characters'
              `${t('productFieldErrors.maxShipmentCharacterErr', {
                count: 30
              })}`
            }
            icon={'rpds-warning'}
            handleCloseAlert={() => {
              this.setState({
                showShipmentAlert: false
              });
            }}
            type={'warning'}
          />
        )}
        {this.state.showDispatchClaimsAlert && (
          <Alert
            styleClass="rp-list-item-alert"
            message={
              // 'Maximum allowable length for Dispatch/Claims marking is 15 characters'
              `${t('productFieldErrors.maxDispatchClaimsMarkingErr', {
                count: 15
              })}`
            }
            icon={'rpds-warning'}
            handleCloseAlert={() => {
              this.setState({
                showDispatchClaimsAlert: false
              });
            }}
            type={'warning'}
          />
        )}
        <div className="rp-list-item">
          <div className="rp-list-item--image-area">
            <div
              className="image-container"
              style={{
                backgroundImage: `url(${
                  this.props.image ? this.props.image : defaultImage
                })`
              }}
            />
          </div>
          <div className="rp-list-item--main-info">
            <div>
              <div className="rp-list-item--name-area">
                <a
                  className="rp-list-item--name-link"
                  href={partDetailUrl(`${this.props.mfc}  ${this.props.name}`)}
                  style={{ cursor: 'pointer' }}
                  onClick={e =>
                    goToPartDetail(`${this.props.mfc}  ${this.props.name}`)
                  }
                >
                  {`${this.props.mfc} ${this.props.name}`}
                </a>
              </div>
              <div className="rp-list-item--description-area">
                {this.props.description}
              </div>
            </div>
            <div className="rp-list-item--prices-area">
              <div className="rp-list-item--prices-single">
                <label>MSRP</label>
                {this.props.retailPrice
                  ? accounting.formatMoney(this.props.retailPrice)
                  : 'NA'}
              </div>
              <div className="rp-list-item--prices-single">
                <label>{t('myFavourites.yourPrice')}</label>
                {this.props.price
                  ? accounting.formatMoney(this.props.price)
                  : 'NA'}
              </div>
              <div className="rp-list-item--prices-single">
                <label>{t('myFavourites.itemTotal')}</label>
                {this.props.total
                  ? accounting.formatMoney(this.props.total)
                  : 'NA'}
              </div>
            </div>
          </div>
          <div className="rp-list-item--optional-info">
            <div className="rp-list-item--stock-area">
              <span
                className={
                  this.props.inStock
                    ? `rpds-check-circle stock-success-icon`
                    : `rpds-error stock-error-icon`
                }
              />
              {this.props.inStock
                ? `${t('common.inStock')}`
                : `${t('common.outOfStock')}`}
            </div>
            <div className="rp-list-item--marks-area">
              {this.renderMarksArea()}
            </div>
          </div>
          <div className="rp-list-item--buttons-area">
            <button
              className="secondary-button"
              onClick={e =>
                this.props.handleRemoveItem(this.props.id, this.props.name)
              }
            >
              {t('common.removeAction')}
            </button>
            <button className="primary-button" onClick={this.addToCart}>
              <span className="rpds-shopping-cart" />
              {t('myFavourites.addToCart')}
            </button>
            {console.log(this.props.alternateProductNumber, 'itempage')}
            {this.props.alternateProductNumber !== null &&
            this.props.oemProductNumber === null ? (
              <button
                className="viewbutton"
                type="button"
                // href={partDetailUrl(
                //   `${this.props.alternateProductManufacturer}  ${this.props.alternateProductNumber}`
                // )}
                onClick={e => {
                  goToPartDetail(
                    `${this.props.alternateProductManufacturer}  ${this.props.alternateProductNumber}`
                  );
                }}
              >
                {t('myFavourites.viewnonoem')}
              </button>
            ) : (
              ''
            )}
            {this.props.oemProductNumber &&
            !this.props.alternateProductNumber ? (
              <button
                className="viewbutton"
                type="button"
                // href={partDetailUrl(
                //   `${this.props.oemProductManufacturer}  ${this.props.oemProductNumber}`
                // )}
                onClick={e => {
                  goToPartDetail(
                    `${this.props.oemProductManufacturer}  ${this.props.oemProductNumber}`
                  );
                }}
              >
                {t('myFavourites.viewoem')}
              </button>
            ) : (
              ''
            )}
            {this.props.replacementMfc && this.props.replacementPart ? (
              <button
                className="subavailable"
                onClick={e => {
                  goToPartDetail(
                    `${this.props.replacementMfc}  ${this.props.replacementPart}`
                  );
                }}
              >
                {t('myFavourites.subavailable')}
              </button>
            ) : (
              ''
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  public render() {
    return this.state.isMobile ? this.renderMobile() : this.renderDesktop();
  }

  public checkForErrors() {
    let ismarkingError: boolean = false;
    if (
      this.props.warrantyProvider &&
      this.props.dispatch &&
      this.props.dispatch.length > 15
    ) {
      ismarkingError = true;
      this.setState({ showDispatchClaimsAlert: true });
    }
    return ismarkingError;
  }
}

export default Item;
